import DashboardCardShowMore from '@src/main/ui/components/common/Dashboard/DashboardCardShowMore/DashboardCardShowMore';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import Modal from '@src/main/ui/components/common/Modal/Modal';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { type FC } from 'react';

interface Props {
  highlighFields?: HighlighFields[];
}

const defaultProps = { highlighFields: undefined };

const DashboardsModal: FC<Props> = ({ highlighFields }) => {
  const { selectedDashboard, setSelectedDashboard } = useDashboardContext();
  const { toggleFavorite } = useUserContext();

  return (
    <>
      {selectedDashboard ? (
        <Modal open handleClose={() => setSelectedDashboard(undefined)}>
          <DashboardCardShowMore
            dashboard={selectedDashboard}
            onClickFavorites={() => toggleFavorite(selectedDashboard)}
            highlighFields={highlighFields}
          />
        </Modal>
      ) : undefined}
    </>
  );
};

DashboardsModal.defaultProps = defaultProps;

export default DashboardsModal;
